import { P2GBox, P2GButton, useTheme } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { DrawerNavigationType } from '~/lib/types/enums';

interface Props {
  selectedNavigationType: DrawerNavigationType;
  onSelectNavigationType: (navigationType: DrawerNavigationType) => void;
  isDropOff: boolean;
}

export const DrawerNavigationMenu = ({ selectedNavigationType, onSelectNavigationType, isDropOff }: Props) => {
  const { t } = useTranslation(TranslationNamespaces.CHECKOUT);
  const onClickNavigationType = (navigationType: DrawerNavigationType) => {
    onSelectNavigationType(navigationType);
  };
  const theme = useTheme();

  return (
    <P2GBox
      sx={{
        display: 'flex',
        gap: 1,
        maxWidth: '455px',
        '& .MuiButton-root': {
          whiteSpace: 'nowrap',
          [theme.breakpoints.down('sm')]: {
            ...theme.typography.body1,
            fontWeight: theme.typography.fontWeightBold
          }
        }
      }}
    >
      <P2GButton
        fullWidth
        variant={selectedNavigationType === DrawerNavigationType.Details ? 'secondary' : 'tertiary'}
        value={DrawerNavigationType.Details.toString()}
        selected={selectedNavigationType.toString()}
        onClick={() => onClickNavigationType(DrawerNavigationType.Details)}
        dataTestId="navigation-menu-details"
        disableRipple
      >
        {t('DETAILS_DRAWER_TAB', { defaultValue: 'Details' })}
      </P2GButton>
      {isDropOff && (
        <P2GButton
          fullWidth
          variant={selectedNavigationType === DrawerNavigationType.DropOff ? 'secondary' : 'tertiary'}
          value={DrawerNavigationType.DropOff.toString()}
          selected={selectedNavigationType.toString()}
          onClick={() => onClickNavigationType(DrawerNavigationType.DropOff)}
          dataTestId="navigation-menu-drop-off"
          disableRipple
        >
          {t('DROP_OFF_DRAWER_TAB', { defaultValue: 'Drop Off' })}
        </P2GButton>
      )}
      <P2GButton
        fullWidth
        variant={selectedNavigationType === DrawerNavigationType.Protection ? 'secondary' : 'tertiary'}
        value={DrawerNavigationType.Protection.toString()}
        selected={selectedNavigationType.toString()}
        onClick={() => onClickNavigationType(DrawerNavigationType.Protection)}
        dataTestId="navigation-menu-protection"
        disableRipple
      >
        {t('PROTECTION_DRAWER_TAB', { defaultValue: 'Protection' })}
      </P2GButton>
    </P2GBox>
  );
};
